import { ChecklistStatus } from '../../../demo/ComponentStatus/ComponentStatus.types';

export const PeoplePickerStatus = {
  keyboardAccessibilitySupport: ChecklistStatus.unknown,
  markupSupport: ChecklistStatus.unknown,
  highContrastSupport: ChecklistStatus.fail,
  rtlSupport: ChecklistStatus.fail,
  testCoverage: ChecklistStatus.none
};